import { Component, ChangeDetectionStrategy, ChangeDetectorRef, NgZone, OnInit } from '@angular/core';
import { ToastService, ToastPayload } from 'src/app/services/toast.service';
import { observeOn } from 'rxjs/operators';
import { asyncScheduler } from 'rxjs';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent implements OnInit {
    visible = false;
    isHiding = false;
    titulo = '';
    mensagem = '';
    tipo: 'sucesso' | 'erro' | 'aviso' | 'info' = 'info';
    defaultDuration = 3000;
    private hideTimeout: any = null;

    constructor(private bus: ToastService, private cdr: ChangeDetectorRef, private zone: NgZone) { }

    ngOnInit(): void {
        this.bus.events$
            .pipe(observeOn(asyncScheduler))
            .subscribe((e: ToastPayload) => {
                this.zone.run(() => {
                    if (this.hideTimeout) { clearTimeout(this.hideTimeout); this.hideTimeout = null; }

                    this.tipo = e.tipo;
                    this.titulo = e.titulo;
                    this.mensagem = e.mensagem;
                    this.isHiding = false;
                    this.visible = true;
                    this.cdr.markForCheck();

                    const dur = Number.isFinite(e.duration) ? e.duration! : this.defaultDuration;
                    this.hideTimeout = setTimeout(() => this.closeNow(), dur);
                });
            });
    }

    closeNow() {
        this.isHiding = true;
        this.cdr.markForCheck();
        setTimeout(() => {
            this.isHiding = false;
            this.visible = false;
            this.cdr.markForCheck();
        }, 140);
    }
}
